import { useContext } from 'react'

import AuthContext from './AuthProvider.context'

/**
 * The AuthProvider's custom hook.
 */
export const useAuthProvider = () => useContext(AuthContext)
